import { extendTailwindMerge } from 'tailwind-merge';

type AdditionalClassGroupIds = 'aspect' | 'carousel-item-w' | 'carousel-stage-gap';

const isArbitraryValue = (classPart: string) => /^\[.+\]$/.test(classPart)

// Read more about how to customize tailwind merge: https://github.com/dcastil/tailwind-merge/blob/v2.0.0/docs/configuration.md

const WIDTHS = ['full', '1/3', '1/2', '1/3', '2/3', '1/4', '2/4', '3/4', '1/5', '2/5', '3/5', '4/5', '1/6', '2/6', '3/6', '4/6', '5/6', '1/12', '2/12', '3/12', '4/12', '5/12', '6/12', '7/12', '8/12', '9/12', '10/12', '11/12'];

const SPACINGS = ['px', '0', '0.5', '1', '1.5', '2', '2.5', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '14', '16', '18', '20', '25', '30'];


// TODO: Document in Storybook / Readme
export const customTwMerge = extendTailwindMerge<AdditionalClassGroupIds>({
  extend: {
    classGroups: {
      aspect: [{
        aspect: ['3/1', '1/1', '5/4', '4/5', '16/9', '9/16', '4/3', '3/4', '3/2', '2/3', '21/9', '9/21'],
      }],
      'carousel-stage-gap': [{
        'carousel-stage-gap': [
          ...SPACINGS,
          isArbitraryValue,
        ]
      }],
      'carousel-item-w': [{
        'carousel-item-w': [
          ...WIDTHS,
          isArbitraryValue,
        ]
      }],
    },
    conflictingClassGroups: {
      'w': ['carousel-item-w'],
      'gap': ['carousel-stage-gap'],
    }
  },
});

export { twJoin } from 'tailwind-merge';
